import React from 'react'
import defaultImage from 'images/placeholders/slide.jpg'
import pdfLogo from 'images/pdf-logo.png'
import Very from "../../../helpers/request_wrapper";

const Universe = ({
  brandPhotos,
  essentialPhotos,
  interestsPhoto,
  limitedView,
  mediaTouchpointPhoto,
  personaId,
  personaName,
  personaPhotos,
  canUnlock
}) => {
  const brandPhotos1 = brandPhotos[0] ? brandPhotos[0].url : defaultImage;
  const essentialPhotos1 = essentialPhotos[0].url;
  const interestsPhoto1 = interestsPhoto[0].url;
  const mediaTouchpointPhoto1 = mediaTouchpointPhoto[0].url;
  const personaPhoto1 = personaPhotos[0].url;
  const personaPhoto2 = personaPhotos[1].url;

  const unlockPersona = () => {
    Very.post(`/personas/${personaId}/unlock`).then(res => {
      window.location.replace(`/personas/${personaId}`)
    }, error => {

    })
  };

  return (
    <React.Fragment>
      <section className="section md-pt4" data-anchor="universe">
        <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex p4 x-lg-p3">
          <div className="col-12 flex">
            <div className="col-12 flex flex-center mxn2 sm-block sm-m0">
              <div className="col-6 px2 sm-col-12 sm-mb-300">
                <h2 className="persona-sub-title mb3">Meet {personaName}</h2>

                <ul className="list-with-circle overflow-hidden text-violet-red">
                  <li className="mb3">The Essentials</li>
                  <li className="mb3">Getting more specific</li>
                  <li className="mb3">Content: When & What</li>
                  <li className="last-element-no-margin mb3">Recommended Strategy</li>
                </ul>
              </div>

              <div className="col-6 flex flex-justify-center px2 sm-col-12 sm-mb-300">
                <div className="col-12 relative" style={{ maxWidth: 430 }}>
                  <div
                    className="persona-image persona-image--1 z1"
                    style={{ backgroundImage: `url('${personaPhoto1}')` }}
                  />

                  <div
                    className="persona-image persona-image--2 z1"
                    style={{ backgroundImage: `url('${personaPhoto2}')` }}
                  />

                  {limitedView && (
                    <div
                      className="absolute bg-black-o-50 center left-0 px2 py3 right-0 top-50p z1"
                      style={{ transform: 'skew(0deg, -18deg) translateY(-50%)' }}
                    >
                      <p className="mb3 text-white">Purchase to get to know {personaName}</p>

                      <div className="bold flex flex-justify-center">
                        {canUnlock ?  <a className="mx2 text-white cursor-pointer" onClick={unlockPersona}>Unlock</a> :
                          <a className="mx2 text-white" href={`/pricing`}>Pay now</a>}

                        <a className="mx2 text-white" href="#" onClick={() => { fullpage_api.moveTo('overview') }}>Preview</a>
                      </div>
                    </div>
                  )}

                  <div
                    className="image-layer image-layer--flirt persona-image persona-image--3"
                    style={{ backgroundImage: `url('${essentialPhotos1}')` }}
                  />

                  <div
                    className="image-layer image-layer--bright-turquoise persona-image persona-image--4"
                    style={{ backgroundImage: `url('${defaultImage}')` }}
                  />

                  <div
                    className="image-layer image-layer--bright-turquoise-extra-light persona-image persona-image--5"
                    style={{ backgroundImage: `url('${defaultImage}')` }}
                  />

                  <div
                    className="image-layer image-layer--denim persona-image persona-image--6"
                    style={{ backgroundImage: `url('${defaultImage}')` }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  )
}

export default Universe
